import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from 'wonderbly-components/lib/Icon';

import './NavItem.scss';

const NavItemContent = ({
  badgeText,
  icon,
  iconColor,
  title,
}) => {
  const badgeColor = iconColor || 'blue-medium';

  return (
    <>
      {icon && (
        <div
          className={cx(
            'nav-item__link__icon',
            { [`color-${iconColor}`]: iconColor },
          )}>
          <Icon icon={icon} />
        </div>
      )}
      {title}
      <div className="nav-item__right">
        {badgeText && (
          <div
            className={cx(
              'nav-item__badge text-micro',
              { [`color-bg-${badgeColor}`]: badgeColor },
            )}>
            {badgeText}
          </div>
        )}
      </div>
    </>
  );
};

NavItemContent.propTypes = {
  badgeText: PropTypes.string,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  title: PropTypes.string.isRequired
};

export default NavItemContent;
